'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _injectPreparedData = require('./injectPreparedData');

var _injectPreparedData2 = _interopRequireDefault(_injectPreparedData);

var _IsomorphicRootContainer = require('./IsomorphicRootContainer');

var _IsomorphicRootContainer2 = _interopRequireDefault(_IsomorphicRootContainer);

var _prepareData = require('./prepareData');

var _prepareData2 = _interopRequireDefault(_prepareData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    injectPreparedData: _injectPreparedData2.default,
    prepareData: _prepareData2.default,
    RootContainer: _IsomorphicRootContainer2.default
};


//////////////////
// WEBPACK FOOTER
// ./~/isomorphic-relay/lib/IsomorphicRelay.js
// module id = 441
// module chunks = 0